import { setContext } from "@apollo/client/link/context";
import { getCurrnetProfileId } from "../../../modules/common/helpers/manageCurrentProfile";
import { getFirebaseIdToken } from "../../firebase";

const authLink = setContext(async (_, { headers }) => {
  try {
    const token = await getFirebaseIdToken();
    const currentProfileId = getCurrnetProfileId();
    // console.info("Token: ", token);
    // console.info("Current Profile Id: ", currentProfileId);
    return {
      headers: {
        ...headers,
        authorization: token,
        currentProfileId,
      },
    };
  } catch (err) {
    console.error("Error in token: ", err);
    if (err === "No current user") {
      return {
        headers,
      };
    }
    throw err;
  }
});

export default authLink;
